import NotificationDrawer from './notification-drawer';

export default NotificationDrawer;